// extracted by mini-css-extract-plugin
export default {"itemLink":"AcademyMenuMovil_itemLink__Po-Jh","itemMenu":"AcademyMenuMovil_itemMenu__QWq48"};